import type { Model } from '@thevillages/schemas';

import { Component, input } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-model-card',
  styleUrl: './model-card.css',
  templateUrl: './model-card.html',
})
export class ModelCard {
  public readonly model = input.required<Model>();
}
